export default __webpack_public_path__ + "static/media/setting.5239e0ff.svg";